/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CheckoutStatus,
    CheckoutStatusFromJSON,
    CheckoutStatusFromJSONTyped,
    CheckoutStatusToJSON,
} from './CheckoutStatus';

/**
 * 
 * @export
 * @interface CheckoutStatusDto
 */
export interface CheckoutStatusDto {
    /**
     * 
     * @type {string}
     * @memberof CheckoutStatusDto
     */
    sessionId: string;
    /**
     * 
     * @type {CheckoutStatus}
     * @memberof CheckoutStatusDto
     */
    status: CheckoutStatus | null;
    /**
     * 
     * @type {string}
     * @memberof CheckoutStatusDto
     */
    lookupKey?: string;
}

export function CheckoutStatusDtoFromJSON(json: any): CheckoutStatusDto {
    return CheckoutStatusDtoFromJSONTyped(json, false);
}

export function CheckoutStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckoutStatusDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sessionId': json['sessionId'],
        'status': CheckoutStatusFromJSON(json['status']),
        'lookupKey': !exists(json, 'lookupKey') ? undefined : json['lookupKey'],
    };
}

export function CheckoutStatusDtoToJSON(value?: CheckoutStatusDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sessionId': value.sessionId,
        'status': CheckoutStatusToJSON(value.status),
        'lookupKey': value.lookupKey,
    };
}

